"use client";

import { useActionState } from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { PasswordInput } from "@/components/password-input";
import { loginAction, type LoginState } from "@/lib/actions/auth";

type Props = {
  callbackUrl?: string;
};

const initialState: LoginState = {};

export function LoginForm({ callbackUrl }: Props) {
  const t = useTranslations("login");
  const [state, formAction, pending] = useActionState(loginAction, initialState);

  return (
    <form action={formAction} className="mt-6 max-w-md space-y-4">
      {callbackUrl ? (
        <input type="hidden" name="callbackUrl" value={callbackUrl} />
      ) : null}
      <div className="space-y-1">
        <label htmlFor="email" className="block text-sm font-medium text-stone-800">
          {t("email")}
        </label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className="w-full rounded-md border border-stone-300 bg-white px-3 py-2 text-stone-900"
        />
      </div>
      <div className="space-y-1">
        <label
          htmlFor="password"
          className="block text-sm font-medium text-stone-800"
        >
          {t("password")}
        </label>
        <PasswordInput
          id="password"
          name="password"
          autoComplete="current-password"
          required
          minLength={8}
          showLabel={t("showPassword")}
          hideLabel={t("hidePassword")}
        />
      </div>
      <p className="text-sm">
        <Link href="/forgot-password" className="underline">
          {t("forgotPassword")}
        </Link>
      </p>
      {state.error ? (
        <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900">
          {t(`errors.${state.error}`)}
        </p>
      ) : null}
      <button
        type="submit"
        disabled={pending}
        className="rounded-md bg-stone-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-stone-800 disabled:opacity-60"
      >
        {pending ? t("submitting") : t("submit")}
      </button>
    </form>
  );
}
